import "./styles/Button.scss";
import { ReactNode } from "react";

type Props = {
  children: ReactNode;
  onClick: () => void;
  className?: string;
  variant?: `primary` | `secondary` | `tertiary`;
  disabled?: boolean;
}

const Button = ({ children, variant, onClick, className, disabled = false, ...rest }: Props) => {
  const classes = [
    `ws-widgets-button`,
    variant ? `ws-widgets-button--` + variant : ``,
    className,
  ]
  return (
    <button
      type={ `button` }
      className={ classes.join(` `) }
      disabled={ disabled }
      onClick={ onClick }
      { ...rest }
    >
      { children }
    </button>
  )
}

export default Button;
